<template>
  <highcharts :options="theChart"></highcharts>
</template>

<script>

  import Vue from 'vue';
  import VueHighcharts from 'vue-highcharts';
  import Highcharts from 'highcharts';
  import loadDrilldown from 'highcharts/modules/drilldown';
  import VueNumeric from 'vue-numeric'
  import _ from 'lodash';

  let elvenStats = require('../lib/elven-stats');
  let elvenCharts = require('../lib/elven-charts');
  let elvenWeeklyReport = require('../lib/elven-weekly-report');
  export default {
    name: 'elv-sparkline',
    props: {
      'player': {   required:true },
      'width': {  required:true, type: Number },
      'height': { required:true, type: Number },
      'type': { required:false, type: String, default: "tournament"}
    },
    computed: {
      theChart: {
        get: function() {
          if( this.type === 'tournament' ) {
            return elvenCharts.getTournamentHistoryChart(this.player,this.$i18n, null, moment().subtract(4,"weeks").format("YYYY-MM-DD"));
          }
          else {
            console.log("Type is not tournament");
            return elvenCharts.getScoreHistoryChart(this.player, this.$i18n, null, moment().subtract(4,'weeks').format('YYYY-MM-DD') );
          }
        }
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/ElvSparkline.vue